import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"

export const dict = {
  ...DESKTOP_NATIVE_ENGLISH,
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Workspace",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.project.index": "Switch to project {{index}}",
  "command.provider.connect": "Connect provider",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.session.archive": "Archive session",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New session",
  "command.file.open": "Open file",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle workspaces",
  "command.workspace.toggle.description": "Enable or disable multiple workspaces in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.share": "Share session",
  "command.session.share.description": "Share this session and copy the URL to clipboard",
  "command.session.unshare": "Unshare session",
  "command.session.unshare.description": "Stop sharing this session",
  "command.session.export": "Export session",
  "command.session.export.description": "Export the full session transcript as JSON",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.search.placeholder.home": "Search commands and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models, including Pro and Max",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenCode",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.title.anthropicProMax": "Login with Claude Pro/Max",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress...",
  "provider.connect.status.waiting": "Waiting for authorization...",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.opencodeZen.line1":
    "OpenCode Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.opencodeZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.opencodeZen.visit.prefix": "Visit ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OpenCode.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "...",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving...",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command... {{example}}",
  "prompt.placeholder.normal": 'Ask anything... "{{example}}"',
  "prompt.placeholder.simple": "Ask anything...",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.example.1": "Fix a TODO in the codebase",
  "prompt.example.2": "What is the tech stack of this project?",
  "prompt.example.3": "Fix broken tests",
  "prompt.example.4": "Explain how authentication works",
  "prompt.example.5": "Find and fix security vulnerabilities",
  "prompt.example.6": "Add unit tests for the user service",
  "prompt.example.7": "Refactor this function to be more readable",
  "prompt.example.8": "What does this error mean?",
  "prompt.example.9": "Help me debug this issue",
  "prompt.example.10": "Generate API documentation",
  "prompt.example.11": "Optimize database queries",
  "prompt.example.12": "Add input validation",
  "prompt.example.13": "Create a new component for...",
  "prompt.example.14": "How do I deploy this project?",
  "prompt.example.15": "Review my code for best practices",
  "prompt.example.16": "Add error handling to this function",
  "prompt.example.17": "Explain this regex pattern",
  "prompt.example.18": "Convert this to TypeScript",
  "prompt.example.19": "Add logging throughout the codebase",
  "prompt.example.20": "What dependencies are outdated?",
  "prompt.example.21": "Help me write a migration script",
  "prompt.example.22": "Implement caching for this endpoint",
  "prompt.example.23": "Add pagination to this list",
  "prompt.example.24": "Create a CLI command for...",
  "prompt.example.25": "How do environment variables work here?",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.dropzone.label": "Drop images, PDFs, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.menu.addImagesAndFiles": "Add files and more",
  "prompt.menu.imagesAndFiles": "Images and files",
  "prompt.menu.commands": "Commands",
  "prompt.menu.context": "Context",
  "prompt.menu.shellCommand": "Shell command",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.pasteUnsupported.title": "Unsupported attachment",
  "prompt.toast.pasteUnsupported.description": "Only images, PDFs, or text files can be attached here.",
  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in opencode.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.clickToAuthenticate": "Click to authenticate",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",
  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically...",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OpenCode server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking...",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.username": "Username (optional)",
  "dialog.server.add.usernamePlaceholder": "username",
  "dialog.server.add.password": "Password (optional)",
  "dialog.server.add.passwordPlaceholder": "password",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating...",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.opencode": "OpenCode",
  "wsl.onboarding.checkingRuntime": "Checking WSL...",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros...",
  "wsl.onboarding.installingDistro": "Installing {{distro}}...",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}...",
  "wsl.onboarding.listingDistros": "Listing distros...",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OpenCode...",
  "wsl.onboarding.checkingOpencodeIn": "Checking OpenCode in {{distro}}...",
  "wsl.onboarding.updatingOpencode": "Updating OpenCode...",
  "wsl.onboarding.updatingOpencodeIn": "Updating OpenCode in {{distro}}...",
  "wsl.onboarding.updateOpencodeIn": "Update OpenCode in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OpenCode",
  "wsl.onboarding.opencodeReadyIn": "OpenCode is ready in {{distro}}.",
  "wsl.onboarding.opencodeReady": "OpenCode is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OpenCode in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OpenCode",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading...",
  "wsl.onboarding.installedDistros": "Installed distros",
  "wsl.onboarding.checkAgain": "Check again",
  "wsl.onboarding.distroStatus.ready": "Ready",
  "wsl.onboarding.distroStatus.checking": "Checking...",
  "wsl.onboarding.distroStatus.opencodeMissing": "OpenCode not installed",
  "wsl.onboarding.distroStatus.missingTools": "Missing bash, curl",
  "wsl.onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "wsl.onboarding.needAnotherDistro": "Need another distro?",
  "wsl.onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "wsl.onboarding.wslNotInstalled.title": "WSL not installed",
  "wsl.onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OpenCode can add a WSL server",
  "wsl.onboarding.wslUnavailable.title": "WSL unavailable",
  "wsl.onboarding.wslUnavailable.description": "OpenCode could not verify WSL on this machine.",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenCode.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing...",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.searchDistros": "Search distros",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding...",

  "help.tabs.toast.ariaLabel": "Introducing Tabs. Organize your work and active sessions with tabs",
  "help.tabs.toast.dismiss": "Dismiss Tabs information",
  "help.tabs.title": "Introducing Tabs",
  "help.tabs.description": "Organize your work and active sessions with tabs",
  "help.tabs.date": "July 14",
  "help.tabs.introduction": "OpenCode Desktop is now built around tabs.",
  "help.tabs.sessions":
    "Start a new session in a tab, or open an existing session from any of your projects. Open a new tab when you're starting something new, and close it when you're done.",
  "help.tabs.organize":
    "Keeping a few tabs open makes it easier to organize your active sessions. Rename tabs to something memorable if you plan to keep them around.",
  "help.tabs.home":
    "You'll find all your sessions and projects on the new Home screen. Selecting a session opens it in a tab.",
  "help.tabs.persistence": "When you reopen the app, your tabs are still open.",
  "help.tabs.worktrees":
    "The new design does not support Git Worktrees yet, it's coming soon. So if you'd prefer to continue using the previous layout, you can switch between layouts in Settings. Just keep in mind that the new layout will become permanent in a few weeks.",
  "server.row.noUsername": "no username",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Workspace startup script",
  "dialog.project.edit.worktree.startup.description": "Runs after creating a new workspace (worktree).",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",
  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",
  "context.export.session": "Export session",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Usage",
  "context.usage.cost": "Cost",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Workspaces enabled",
  "toast.workspace.enabled.description": "Multiple worktrees are now shown in the sidebar",
  "toast.workspace.disabled.title": "Workspaces disabled",
  "toast.workspace.disabled.description": "Only the main worktree is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this session",

  "toast.file.loadFailed.title": "Failed to load file",
  "toast.file.listFailed.title": "Failed to list files",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.share.copyFailed.title": "Failed to copy URL to clipboard",
  "toast.session.share.success.title": "Session shared",
  "toast.session.share.success.description": "Share URL copied to clipboard!",
  "toast.session.share.failed.title": "Failed to share session",
  "toast.session.share.failed.description": "An error occurred while sharing the session",

  "toast.session.unshare.success.title": "Session unshared",
  "toast.session.unshare.success.description": "Session unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare session",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the session",

  "toast.session.export.success.title": "Session exported",
  "toast.session.export.success.description": "Saved session to {{filename}}",
  "toast.session.export.failed.title": "Failed to export session",
  "toast.session.export.failed.description": "An error occurred while exporting the session",

  "toast.session.listFailed.title": "Failed to load sessions for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OpenCode ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking...",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "Please report this error to the OpenCode team",
  "error.page.report.discord": "on Discord",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenCode does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",
  "home.title": "Home",
  "home.projects": "Projects",
  "home.project.add": "Add project",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search sessions",
  "home.sessions.search.placeholder.scoped": "Search sessions in {{scope}}",
  "home.sessions.search.sessions": "Sessions",
  "home.sessions.search.noResults": "No sessions found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create a session to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",

  "session.tab.session": "Session",
  "session.tab.review": "Review",
  "session.tab.context": "Context",
  "session.tab.unknown": "Unknown Session",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This session cannot be found",
  "session.error.notFound.description": "This tab points to a session that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.serverConnection": "Can't connect to this server",
  "session.review.filesChanged": "Files Changed {{count}}",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes...",
  "session.review.empty": "No changes in this session yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository...",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so session changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.empty": "No files",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages...",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages...",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",
  "session.question.pending.one": "{{count}} pending question",
  "session.question.pending.other": "{{count}} pending questions",
  "session.followupDock.summary.one": "{{count}} queued message",
  "session.followupDock.summary.other": "{{count}} queued messages",
  "session.followupDock.sendNow": "Send now",
  "session.followupDock.edit": "Edit",
  "session.followupDock.collapse": "Collapse queued messages",
  "session.followupDock.expand": "Expand queued messages",
  "session.revertDock.summary.one": "{{count}} rolled back message",
  "session.revertDock.summary.other": "{{count}} rolled back messages",
  "session.revertDock.collapse": "Collapse rolled back messages",
  "session.revertDock.expand": "Expand rolled back messages",
  "session.revertDock.restore": "Restore message",

  "session.new.title": "Build anything",
  "session.new.project.new": "New project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.workspace.runIn": "Run session in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existing": "Workspace…",
  "session.new.git.none": "No Git",
  "session.new.lastModified": "Last modified",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "session.share.popover.title": "Publish on web",
  "session.share.popover.description.shared":
    "This session is public on the web. It is accessible to anyone with the link.",
  "session.share.popover.description.unshared":
    "Share session publicly on the web. It will be accessible to anyone with the link.",
  "session.share.action.share": "Share",
  "session.share.action.publish": "Publish",
  "session.share.action.publishing": "Publishing...",
  "session.share.action.unpublish": "Unpublish",
  "session.share.action.unpublishing": "Unpublishing...",
  "session.share.action.view": "View",
  "session.share.copy.copied": "Copied",
  "session.share.copy.copyLink": "Copy link",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "Loading prompt...",
  "terminal.loading": "Loading terminal...",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",
  "terminal.connectTicket.csrfError":
    "PTY connect ticket rejected by origin or CSRF checks. Check the server CORS config.",
  "terminal.connectTicket.statusError": "PTY connect ticket failed with {{status}}",

  "titlebar.update": "Update",
  "titlebar.updateVersion": "Update {{version}}",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and sessions",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.workspaces.enable": "Enable workspaces",
  "sidebar.workspaces.disable": "Disable workspaces",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "OpenCode includes free models so you can start immediately.",
  "sidebar.gettingStarted.line2": "Connect any provider to use models, inc. Claude, GPT, Gemini etc.",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.viewAllSessions": "View all sessions",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.na": "n/a",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "Force focus styles on all interactive elements",
  "debugBar.focus.on": "ON",
  "debugBar.focus.off": "OFF",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "Force the full app layout direction without changing the selected language",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",

  "app.name.desktop": "OpenCode Desktop",

  "settings.section.desktop": "Desktop",
  "settings.section.server": "Server",
  "settings.tab.general": "General",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OpenCode server inside WSL on Windows.",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "System notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenCode",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OpenCode looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenCode follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenCode is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.followup.title": "Follow-up behavior",
  "settings.general.row.followup.description": "Choose whether follow-up prompts steer immediately or wait in a queue",
  "settings.general.row.followup.option.queue": "Queue",
  "settings.general.row.followup.option.steer": "Steer",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree panel in sessions",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the title bar",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description":
    "Place the title bar and session tabs at the bottom of the screen on mobile",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.row.newInterface.title": "New layout",
  "settings.general.row.newInterface.badge": "New",
  "settings.general.row.newInterface.description":
    "Use the new tabs and home layout. Switch between layouts for a limited time.",
  "settings.general.row.newInterfaceNotice.title": "You're now using new layout",
  "settings.general.row.newInterfaceNotice.description": "The previous layout is no longer available",
  "settings.general.row.newInterfaceNotice.dismiss": "Dismiss",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OpenCode launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking...",
  "settings.updates.action.downloading": "Downloading...",
  "settings.updates.action.installing": "Installing...",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OpenCode.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Provider settings will be configurable here.",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Model settings will be configurable here.",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New workspace",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create workspace",
  "workspace.delete.failed.title": "Failed to delete workspace",
  "workspace.resetting.title": "Resetting workspace",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset workspace",
  "workspace.reset.success.title": "Workspace reset",
  "workspace.reset.success.description": "Workspace now matches the default branch.",
  "workspace.error.stillPreparing": "Workspace is still preparing",
  "workspace.status.checking": "Checking for unmerged changes...",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes detected in this workspace.",
  "workspace.delete.title": "Delete workspace",
  "workspace.delete.confirm": 'Delete workspace "{{name}}"?',
  "workspace.delete.button": "Delete workspace",
  "workspace.reset.title": "Reset workspace",
  "workspace.reset.confirm": 'Reset workspace "{{name}}"?',
  "workspace.reset.button": "Reset workspace",
  "workspace.reset.archived.none": "No active sessions will be archived.",
  "workspace.reset.archived.one": "1 session will be archived.",
  "workspace.reset.archived.many": "{{count}} sessions will be archived.",
  "workspace.reset.note": "This will reset the workspace to match the default branch.",
}
